import { CreatecustomfromComponent } from "./createcustomfrom/createcustomfrom.component";
import { EditcustomfromComponent } from "./editcustomfrom/editcustomfrom.component";
import { ViewcustomfromComponent } from "./viewcustomfrom/viewcustomfrom.component";

export const CustomFromRouting = [
    { path: '', redirectTo: 'view-custom-form', pathMatch: 'full' },
    {path:'add-custom-form',component:CreatecustomfromComponent},
    {path:'edit-custom-form',component:EditcustomfromComponent},
    {path:'view-custom-form',component:ViewcustomfromComponent},
];

export const CustomFromRoutingBreadcrumbs = [
    { name: 'View',path:'' },
    { name: 'View',path:'/view-custom-form' },
    { name: 'Edit', path: '/edit-custom-form' },
    { name: 'Add', path: '/add-custom-form' },

];